const actionTypes = {
  START_DATASERVICE_PROCESSING: "START_DATASERVICE_PROCESSING",
  STOP_DATASERVICE_PROCESSING: "STOP_DATASERVICE_PROCESSING",
  CALCULATE_USED_TIME: "CALCULATE_USED_TIME",
};
export default actionTypes;
